<template>
  <div>
    <nav class="navbar navbar-expand-md justify-content-around">
      <!-- this appears to be some bootstrap throwback that is either broken, or useless, commenting out the link because you can't click it anyway due to 🔮 -->
      <div class="navbar-nav logoHeader">
        <!-- <router-link to="/" class="navbar-brand">
          <img class="img-fluid"/>
        </router-link> -->
      </div>

      <!-- Hamburger when small screen -->
      <button class="navbar-toggler navbar-light" type="button" @click="isMenuOpen = !isMenuOpen"
              aria-controls="navbarSupportedContent" :aria-expanded="isMenuOpen" aria-label="Toggle Navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" :class="{ 'show': isMenuOpen }" id="navbarSupportedContent">
        <ul class="navbar-nav text-nowrap">
          <li class="nav-item">
            <router-link v-if="checkAccess('/home')" to="/home" class="nav-link text-end">
              <font-awesome-icon icon="home" class="mr-1"/>
              <b>Home</b>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link v-if="checkAccess('/admin')" to="/admin" class="nav-link text-end">
              <font-awesome-icon icon="user-secret" class="mr-1"/>
              <b>Admin Board</b>
            </router-link>
          </li>
          <li class="nav-item">
            <a v-if="checkAccess('/gateways')" @click="goToMyView" class="nav-link text-end" style="cursor: pointer"><b>My View</b></a>
          </li>
          <li class="nav-item">
            <router-link v-if="checkAccess('/auditDB')" to="/auditDB" class="nav-link text-end"><b>Audit DB</b></router-link>
          </li>
        </ul>
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <a class="nav-link text-end" @click="toggleDark">
              <font-awesome-icon v-if="isDark" icon="sun"/>
              <font-awesome-icon v-else icon="moon"/>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-end" href="https://apgsensors.com/settler-explorer-remote-monitoring/"
               target="_blank" rel="noopener noreferrer" title="Help">
              <font-awesome-icon :icon="['far', 'question-circle']"/>
            </a>
          </li>
          <template v-if="!currentUser">
            <li class="nav-item text-end">
              <router-link to="/register" class="nav-link">
                <font-awesome-icon icon="user-plus"/>
                Sign Up
              </router-link>
            </li>
            <li class="nav-item text-end">
              <router-link to="/login" class="nav-link">
                <font-awesome-icon icon="sign-in-alt"/>
                Login
              </router-link>
            </li>
          </template>
          <template v-else>
            <li v-if="checkAccess('/profile')" class="nav-item text-end">
              <router-link to="/profile" class="nav-link">
                <font-awesome-icon icon="user"/>
                {{ currentUser?.username }}
              </router-link>
            </li>
            <li class="nav-item text-end">
              <a class="nav-link" @click.prevent="logOut">
                <font-awesome-icon icon="sign-out-alt"/>
              </a>
            </li>
          </template>
        </ul>
      </div>
    </nav>

    <div class="container-fluid">
      <router-view/>
    </div>
  </div>
</template>

<script>
import {useDark, useToggle} from '@vueuse/core';
import routeAccessService from "@/services/routeAccess.service";
import socketInstance from "@/services/Socket";

export default {
  computed: {
    currentUser() {
      return this.$store.state.auth.user
    },
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
      socketInstance.resetSocket();
    },
    toggleDark() {
      // css toggle
      this.darkToggle();
    },
    checkAccess(path){
      let user_type = this.currentUser?.user?.Info?.user_type;
      let allowedPages = routeAccessService(user_type);
      return allowedPages.includes(path);
    },
    goToMyView() {
      if (this.$route.path === '/gateways') {
        this.$store.dispatch('MyView/resetView');
      } else {
        this.$store.dispatch('MyView/resetView');
        this.$router.push('/gateways');
      }
    },
    handleKeydown(event) {
      if (event.key === this.goldCode[this.goldIndex]) {
        this.goldIndex++;
        if (this.goldIndex === this.goldCode.length) {
          this.$store.dispatch('ui/setGatedVisibility', true);
          this.goldIndex = 0;
        }
      } else {
        this.goldIndex = 0; // Reset if sequence breaks
      }
    }
  },
  data() {
    return {
      isMenuOpen: false,
      goldCode: ['g','o','l','d','o','n','t','h','e','c','e','i','l','i','n','g'],
      goldIndex: 0,
    }
  },
    setup() {
    const isDark = useDark();
    const darkToggle = useToggle(isDark);
    return {
      isDark,
      darkToggle,
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeydown);
  }
}
</script>

<style>
.navbar-collapse.show {
  padding-right: 5%;
}
/* Fix conflict between Tailwind and Bootstrap collapse classes */
.navbar-collapse.collapse {
  visibility: visible !important;
}
.navbar-collapse {
  flex-grow:0!important;
}
</style>